import { useState, useEffect } from "react";
import { ethers } from "ethers";
// import Web3 from "web3";
// import TOKENS from "../../tokens.json";
// import genericErc20Abi from "../../tokens/Erc20.json";
import { useSelector } from "react-redux";

import "./walletsBalances.css";
import SetTitle from "../../components/setTitle/SetTitle";
import { walletShort } from "../../components/common/dataShort";
import TokenBalance from "./TokenBalance";

// import Button from "@mui/material/Button";

const NODES = {
  BSC: { node: "https://bsc-dataseed.binance.org/", abbr: "BNB @ BSC" }, //200
  Polygon: { node: "https://polygon-rpc.com/", abbr: "MATIC @ Polygon" }, //300
  Avax: { node: "https://api.avax.network/ext/bc/C/rpc" }, //500
  Celo: { node: "https://forno.celo.org" }, //600
  // Ethereum: process.env.ETH_NODE_ALCHEMY, //100
  Ethereum: { node: "https://cloudflare-eth.com" }, //100
  Fantom: { node: "https://rpc.ftm.tools/" }, //400
  Cronos: { node: "https://evm-cronos.crypto.org" }, //700
  Moonriver: { node: "https://rpc.moonriver.moonbeam.network" }, //1200
  Harmony: { node: "https://api.harmony.one", abbr: "ONE @ Harmony" }, //1300
  //Solana  //800
  //Terra   //900
  //Waves   //1000
  //Kava    //1100
};

const initialBalancesA = {
  Ethereum: "-",
  BSC: "-",
  Polygon: "-",
  Fantom: "-",
  Avax: "-",
  Celo: "-",
  Cronos: "-",
  Moonriver: "-",
  Harmony: "-",
};

export default function WalletsBalances(props) {
  // console.log("props: ", props);

  SetTitle("Balances @ DefiWatch.biz");

  const walletAbbr = useSelector((state) => state.settings.walletAbbr);

  // const [balancesA, setBalancesA] = useState({});
  const [resolvedBalances, setResolvedBalances] = useState([]);

  // const ethers = Ethers.getDefaultProvider();
  // const web3 = new Web3(
  //   new Web3.providers.HttpProvider(
  //     "https://mainnet.infura.io/v3/9bc9d5091ac449db840a195380e0b55b"     //tm
  //   )
  // );

  // // useEffect(() => {
  // //   if (props.userWallets[0].wallet) {
  // const addresses = [props.userWallets[0].wallet]; // ['0x123...', '0x456...'];
  // // const addresses = ["0xAfbE5E703B47Aa57F75a5Dd805651eBA13ea135F"]; // ['0x123...', '0x456...'];
  // const address = addresses[0];
  // // const tokens = TOKENS; // ["0x0", "0x789..."];
  // //   }
  // // }, [props.userWallets]);

  // const ethers = require("ethers");

  useEffect(() => {
    try {
      // for (const userWallet of props.userWallets) {
      //   const address = userWallet.wallet;

      //   for (const [blockchain, network] of Object.entries(NODES)) {
      //     const provider = ethers.getDefaultProvider(network);

      //     1 &&
      //       provider.getBalance(address).then((balance) => {
      //         const balanceInEth = ethers.utils.formatEther(balance); // wei to ether
      //         setBalancesA((prevV) => {
      //           const newV = { ...prevV };
      //           if (typeof newV[address] === "undefined")
      //             newV[address] = initialBalancesA;
      //           newV[address][blockchain] = balanceInEth;
      //           return newV;
      //         });
      //       });
      //   }

      //   getTokenBalance(address).then((bal) =>
      //     console.log(address, bal, "BUSD on BSC blockchain")
      //   );
      // }

      async function resolveWallets(wallets) {
        const r = await Promise.all(
          wallets.map((wallet) => {
            return resolveBlockchainBalances(wallet);
          })
        );
        // console.log(r);
        setResolvedBalances(r);
      }

      async function resolveBlockchainBalances(wallet) {
        const address = wallet.wallet;

        wallet.balances = await Promise.all(
          Object.keys(NODES).map((key) => {
            const network = NODES[key].node;
            const provider = ethers.getDefaultProvider(network);
            // console.log("resolveBlockchainBalances()=", address);

            return provider.getBalance(address).then((balance) => ({
              // [key]: ethers.utils.formatEther(balance), // wei to ether
              blockchain: key,
              balance: ethers.utils.formatEther(balance),
            }));
          })
        );

        return wallet;
      }

      // const activeUsers = await post.getActiveUsers();
      // const resolvedUsers = await resolveUsers(activeUsers);
      resolveWallets(props.userWallets);
    } catch (e) {
      console.log(e);
    }
  }, [props.userWallets]);
  // }, []);

  // useEffect(() => {
  //   console.log("balA", Object.keys(balancesA).length, balancesA);
  // }, [balancesA]);
  // useEffect(() => {
  //   console.log(resolvedBalances);
  // }, [resolvedBalances]);

  return (
    <div className="pageWalletsBalances">
      <h1>Balances</h1>

      <div className="walletBalances">
        {/* {props.userWallets.map((userWallet) => (
          <div className="walletBalances_1" key={userWallet.wallet}>
            <h2>
              {walletAbbr ? walletShort(userWallet.wallet) : userWallet.wallet}
            </h2>
            {balancesA[userWallet.wallet]
              ? Object.keys(balancesA[userWallet.wallet]).map((blockchain) => (
                  <div key={userWallet.wallet + blockchain}>
                    <label>{blockchain}: </label>
                    <span>
                      {+(+balancesA[userWallet.wallet][blockchain]).toFixed(4)}
                    </span>
                  </div>
                ))
              : "Loading..."}
          </div>
        ))} */}
        {resolvedBalances.map((row) => (
          <div className="walletBalances_1" key={row.wallet}>
            <h2>{walletAbbr ? walletShort(row.wallet) : row.wallet}</h2>
            <b className="titleCoins">Coins</b>
            {row.balances.map((balance) => (
              <div key={row.wallet + balance.blockchain}>
                <label>
                  {NODES[balance.blockchain].abbr !== undefined
                    ? NODES[balance.blockchain].abbr
                    : balance.blockchain}
                  :{" "}
                </label>
                <span>{+(+balance.balance).toFixed(4)}</span>
              </div>
            ))}
            <b className="titleTokens">Tokens</b>
            <TokenBalance wallet={row.wallet} NODES={NODES} />
          </div>
        ))}

        {/* <div>{Object.keys(balancesA).length}</div> */}

        {/* {Object.keys(balancesA).map((wallet) => (
        <div className="walletBalances" key={wallet}>
          <h2>{wallet}</h2>
          {Object.keys(balancesA[wallet]).map((blockchain) => (
            <div key={wallet + blockchain}>
              <label>{blockchain}: </label>
              <span>{+(+balancesA[wallet][blockchain]).toFixed(4)}</span>
            </div>
          ))}
        </div>
      ))} */}

        {/* {props.userWallets[0]?.wallet} */}
        {/* {props.userWallets.map((row) => {
        return (
          <div className="walletRow">
            <span>{row.wallet}</span>
            <label className="walletBadgePaid">Paid</label>
            <label>2022-01-17 - 2022-08-17</label>
            <Button className="extraSmall">Extend</Button>
          </div>
        );
      })}

      <Button variant="outlined" className="extraSmall addAdditionalWallet">
        Add Additional Wallet to Monitor
      </Button> */}
      </div>
    </div>
  );
}
